import { toastManager } from "~/components/ui/toast";

export async function uploadProjectTaskFiles(
  files: readonly File[],
  upload: (files: readonly File[]) => Promise<void>,
): Promise<void> {
  try {
    await upload(files);
    toastManager.add({
      type: "success",
      title: files.length === 1 ? "File attached" : "Files attached",
    });
  } catch (cause) {
    toastManager.add({
      type: "error",
      title: "Upload failed",
      description: cause instanceof Error ? cause.message : undefined,
    });
  }
}
